// Shared constants for Executive Dashboard sections. All sections read the
// current user via useAuth() from AuthContext, so no additional context
// provider is needed here.
export const API = process.env.REACT_APP_BACKEND_URL + '/api';
